<div class="window-container">
    <div class="alert-container">
        <div class="modal-title">{{ "outOfZone.title" | translate}}</div>
        <div class="modal-description">{{ "outOfZone.description" | translate}}</div>
        <div class="checkbox-container">
            <input class="checkboxInput" type="checkbox" name="noShow">
            <label for="noShow">{{ "outOfZone.check-msg" | translate}}</label>
        </div>
        <div class="modal-controls">
            <!-- <button class="btn rounded-pill btn-modal-cancel btn-modal" (click)="onCancel()">{{"Cancel" | translate
                }}</button> -->
            <button class="btn rounded-pill btn-modal-action btn-modal" (click)="onConfirm()">
                {{ "outOfZone.btn-ok-msg" | translate}}</button>
        </div>
    </div>
</div>